import { Component } from '@angular/core';

@Component({
  selector: 'uni-step-separator',
  templateUrl: './uni-step-separator.component.html',
  styleUrls: ['./uni-step-separator.component.scss'],
})
export class UniStepSeparatorComponent {}
